import React from 'react';

import { DescriptionOutlined,NoteAddOutlined, SearchOutlined} from '@mui/icons-material';

import {ErrorOutline, PatientOutlined} from '../../Common/components/Icons/icons';

export const patientTabs = [
  {
    value: 0,
    icon: <PatientOutlined />,
    label: 'Patients'
  },
  {
    value: 1,
    icon: <DescriptionOutlined />,
    label: 'SOAP'
  },
  {
    value: 2,
    icon: <ErrorOutline />,
    label: 'PT Info'
  },
  {
    value: 3,
    icon: <NoteAddOutlined />,
    label: 'PT Doc'
  },
  {
    value: 4,
    icon: <SearchOutlined />,
    label: 'Search'
  }
];